// River Valley Co. — Theme JS

// Add to cart via Shopify AJAX API
async function addToCartShopify(btn) {
  const variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  btn.textContent = '...';
  btn.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (response.ok) {
      // Update cart count in nav
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const cartBtn = document.querySelector('.nav-cart');
      if (cartBtn) cartBtn.textContent = `🛒 Cart (${cart.item_count})`;

      showModal('Added to Cart! 🎩', 'Your hat has been added. Keep browsing or head to checkout.', '🎩');
    } else {
      showModal('Oops!', 'Something went wrong. Please try again.', '😕');
    }
  } catch (err) {
    showModal('Oops!', 'Something went wrong. Please try again.', '😕');
  }

  btn.textContent = 'Add';
  btn.disabled = false;
}

// Modal
function showModal(title, desc, icon) {
  const el = document.getElementById('modal');
  if (!el) return;
  document.getElementById('modal-title').textContent = title || '';
  document.getElementById('modal-desc').textContent = desc || '';
  document.getElementById('modal-icon').textContent = icon || '🌿';
  el.classList.add('active');
}

function closeModal() {
  const el = document.getElementById('modal');
  if (el) el.classList.remove('active');
}

// Close modal on overlay click
document.addEventListener('DOMContentLoaded', function () {
  const overlay = document.getElementById('modal');
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === this) closeModal();
    });
  }

  // Smooth scroll with nav offset
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        const top = target.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });
});
